export default "__VITE_ASSET__Cq1ZdJ94__"